// extracted by mini-css-extract-plugin
export default {"wrapper":"RM4tq","imageWrapper":"LAiCr","image":"B5ZwW","title":"c6WXb","description":"fyI0o"};